


import {LitElementBase} from "#Shared/Lit/LitElementBase";
import {html, rnsg,customElement} from "#Shared/Lit";

@customElement('rn-fontawesome')
export class FontAwesomeIcon extends LitElementBase {

    static get properties(){
        return {
            icon:{type:Object},
            spin:{type:Boolean},
            className:{type:String},
            title:{type:String}
        }
    }

    public onClick:(e:MouseEvent)=>void=null;
    public className='';
    public title:string;
    public icon:any;
    public spin:boolean=false;


    GetDisplay(): string {
        return 'inline-flex'
    }

    constructor() {
        super();
        this.style.alignItems='center';
    }



    public render() {
        if(this.GetViewBox()==null)
            return null;
        return html`
            ${this.spin?html`
                <style>


                    .rnspin {
                        -webkit-animation: rnspin 2s linear infinite;
                        animation: rnspin 2s linear infinite
                    }

                    @-webkit-keyframes rnspin {
                        0% {
                            -webkit-transform: rotate(0deg);
                            transform: rotate(0deg)
                        }

                        to {
                            -webkit-transform: rotate(1turn);
                            transform: rotate(1turn)
                        }
                    }

                    @keyframes rnspin {
                        0% {
                            -webkit-transform: rotate(0deg);
                            transform: rotate(0deg)
                        }

                        to {
                            -webkit-transform: rotate(1turn);
                            transform: rotate(1turn)
                        }
                    }
                </style>
            `:''}
            <svg title="${this.title}" @click="${e=>{this.onClick&&this.onClick(e)}}" fill="currentColor" class="${this.className+(this.spin?' rnspin':'')}" style="${rnsg(
            {height: '1em',display: 'inline-flex',alignItems:'center'})}" viewBox="${this.GetViewBox()}">
                ${this.title!=''?html`<title>${this.title}</title>`:null}
                <path d="${this.GetSVGPath()}"/>
            </svg>
        `
    }

    private GetViewBox():any {
        if(this.icon==null)
            return null;
        let width=this.icon.icon[0];
        let height=this.icon.icon[1];
        return `0 0 ${width} ${height}`;
    }

    private GetSVGPath() {
        if(this.icon==null)
            return null;
        return this.icon.icon[4];
    }
}


//#region ----------------------------------------------------"State and props"------------------------------------------------------------------------------------
interface FontAwesomeIconProps {
    icon:any;
    title:string;
    className:string;
    onClick:(e:MouseEvent)=>void;
}

interface FontAwesomeIconState {

}

//#endregion "My Region"